import { Component, OnInit, Input } from '@angular/core';
import { HistoryComponent } from '../history.component';

@Component({
  selector: 'app-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.css']
})
export class MobileComponent implements OnInit {
  @Input() dataSource: Array<any>;
  p = 1;
  constructor(public historyComponent: HistoryComponent) { }

  ngOnInit() {
  }
}
